import { Button, Tooltip } from '@grupoboticario/flora-react';
import { FiDownload } from 'react-icons/fi';
import { useEffect, useState } from 'react';
import { downloadAllPortalFiles, getPortalUrls } from 'utils/downloadUrls';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store.inteface';

export interface PortalWrapperProps {
  selected: string[];
  franshiceCode: any;
}

export const DownloadMultipleButton = ({
  selected,
  franshiceCode,
}: PortalWrapperProps) => {
  const { cpId } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );
  const [showDownloadButton, setShowDownloadButton] = useState(true);
  const [loading, setLoading] = useState(false);
  async function handleDownloadAll() {
    try {
      setLoading(true);
      const files = await getPortalUrls(
        cpId,
        JSON.stringify(franshiceCode),
        selected,
      );
      await downloadAllPortalFiles(files);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (selected.length > 0) {
      setShowDownloadButton(false);
    } else {
      setShowDownloadButton(true);
    }
  }, [selected]);

  return (
    <div>
      <Tooltip
        align="center"
        direction="top"
        showArrow
        size="standard"
        text="Baixar todos os arquivos selecionadas"
      >
        <Button
          aria-label="Botão de download"
          hierarchy="primary"
          disabled={showDownloadButton}
          onClick={handleDownloadAll}
          isLoading={loading}
          has="iconOnly"
          icon={<FiDownload size={18} />}
        />
      </Tooltip>
    </div>
  );
};
